/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

const DEFAULT_ENTITY_DISPLAY_NAMES = {
    bug: "bug",
    episode: "episode",
    sequence: "sequence",
    shot: "shot",
};
export default DEFAULT_ENTITY_DISPLAY_NAMES;
